import React, { useContext, useEffect, useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import OAuthRepository from 'domain/repository/oauth/OAuthRepository'
import SessionRepository from 'domain/repository/session/SessionRepository'
import AccessToken from 'domain/entity/session/models/AccessToken'
import RefreshToken from 'domain/entity/session/models/RefreshToken'
import { LoadingSpinner } from 'presentation/shared/LoadingSpinner'
import { AppContext } from 'context'

export default function OAuthCallbackScreen() {
	const navigate = useNavigate()
	const { signIn } = useContext(AppContext)
	const handled = useRef(false)

	useEffect(() => {
		if (handled.current) return
		handled.current = true

		const params = new URLSearchParams(window.location.search)
		const code = params.get('code')
		const error = params.get('error')

		if (error || !code) {
			navigate('/login', { replace: true })
			return
		}

		const oauthRepo = new OAuthRepository()
		const sessionRepo = new SessionRepository()

		oauthRepo
			.exchangeCode(code)
			.then(({ accessToken, refreshToken }) => {
				sessionRepo.saveAccessToken(new AccessToken(accessToken))
				sessionRepo.saveRefreshToken(new RefreshToken(refreshToken))
				OAuthRepository.markAsOAuthProvider()
				return signIn()
			})
			.then(() => {
				navigate('/', { replace: true })
			})
			.catch(err => {
				console.error('OAuth callback error:', err)
				navigate('/login', { replace: true })
			})
	}, [])

	return (
		<div className='fixed inset-0 flex items-center justify-center'>
			<LoadingSpinner />
		</div>
	)
}
